const selectedQuestions = state => state.selectedQuestions
const examSelected = state => state.examSelected

export default {
  selectedQuestions,
  examSelected
}
